export default {
	"permission": {
		"role": "role",
		"addRole": "add role",
		"roleName": "role name",
		"roleNameTips": "please fill in the role name"
	}
}


// WEBPACK FOOTER //
// ./src/lang/en/pages/permission/permission.js